import Reveal from "@/components/base/Reveal";

const metaPoints = [
  "CPAs explodindo",
  "Concorrência absurda",
  "Contas bloqueadas toda hora",
  "Público saturado",
];

const kwaiPoints = [
  "Custo por aquisição menor",
  "Pouquíssima concorrência",
  "Audiência nova e engajada",
  "BM liberada para você rodar",
  "Gestão é um serviço à parte",
];

export default function MetaVsKwai() {
  return (
    <section className="py-16 md:py-20 px-4">
      <div className="max-w-lg mx-auto">
        <Reveal>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-center text-foreground-950 mb-3">
            Meta vs Kwai
          </h2>
          <p className="text-center text-foreground-600 text-sm mb-10">
            Onde seu dinheiro rende mais hoje?
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Meta — negative */}
          <Reveal delay={100}>
            <div className="rounded-xl border border-red-500/20 bg-red-500/5 p-5 relative overflow-hidden">
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center">
                <i className="ri-close-line text-red-400 text-lg"></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-800 mb-4 flex items-center gap-2">
                <i className="ri-facebook-circle-line text-foreground-600"></i>
                Meta Ads
              </h3>
              <ul className="space-y-3">
                {metaPoints.map((pt) => (
                  <li key={pt} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-close-circle-line text-red-400/80 mt-0.5 shrink-0"></i>
                    {pt}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Kwai — positive */}
          <Reveal delay={200}>
            <div className="rounded-xl border border-green-500/30 bg-green-500/5 p-5 relative overflow-hidden">
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-green-500/15 flex items-center justify-center">
                <i className="ri-check-line text-green-400 text-lg"></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-4 flex items-center gap-2">
                <span className="text-green-500 font-bold">K</span>
                wai Ads
              </h3>
              <ul className="space-y-3">
                {kwaiPoints.map((pt) => (
                  <li key={pt} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-green-400 mt-0.5 shrink-0"></i>
                    {pt}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={300}>
          <div className="mt-6 text-center">
            <p className="text-sm text-foreground-500 italic">
              "Enquanto todo mundo briga pelo mesmo público no Meta, o Kwai é território quase inexplorado."
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}